if (!customElements.get('delan-ring-filters')) {
  customElements.define('delan-ring-filters', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const basePath = this.dataset.collectionUrl;
      if (location.pathname.replace(/\/$/, '') !== basePath) {
        const url = new URL(location.href);
        const tag = location.pathname.split('/').filter(Boolean).at(-1).replaceAll('-', '_');
        url.pathname = basePath;
        if (['round','oval','pear','emerald_cut','cushion','radiant','marquise'].includes(tag)) url.searchParams.set('ring_shape', tag);
        location.replace(url);
        return;
      }
      this.form = this.querySelector('form');
      this.setAttribute('data-filter-ready','');
      this.querySelector('.dr-mobile-toggle').addEventListener('click', event => {
        const open = this.form.classList.toggle('is-open');
        event.currentTarget.setAttribute('aria-expanded', String(open));
      });
      this.grid = this.querySelector('.dr-grid');
      this.items = Array.from(this.querySelectorAll('.dr-product')).map((el, index) => {
        const title = el.dataset.ringTitle;
        const matches = [...title.matchAll(/(\d+(?:\.\d+)?)ct/gi)];
        const carat = matches.length > 1 ? Number(matches.at(-1)[1]) : 0;
        const t = (title + '|' + el.dataset.tags).toLowerCase();
        const shape = t.includes('radiant') ? 'radiant' : t.includes('marquise') ? 'marquise' : t.includes('pear') ? 'pear' : t.includes('oval') ? 'oval' : t.includes('emerald') ? 'emerald_cut' : t.includes('cushion') ? 'cushion' : 'round';
        return { el, index, title, carat, shape, metal: matches[0]?.[1] + 'ct', plain: !t.includes('diamond shoulders'), shoulders: t.includes('diamond shoulders'), halo: t.includes('halo'), price: Number(el.dataset.price), priceMax: Number(el.dataset.priceMax) };
      });
      this.pLow = this.querySelector('[data-price-lower]');
      this.pHigh = this.querySelector('[data-price-upper]');
      this.priceMax = Math.ceil(Math.max(...this.items.map(i => i.priceMax), 1));
      [this.pLow, this.pHigh].forEach(el => { el.max = this.priceMax; });
      this.pHigh.value = this.priceMax;
      this.form.addEventListener('submit', event => event.preventDefault());
      this.form.addEventListener('input', event => {
        if (event.target === this.pLow && +this.pLow.value > +this.pHigh.value) this.pHigh.value = this.pLow.value;
        if (event.target === this.pHigh && +this.pHigh.value < +this.pLow.value) this.pLow.value = this.pHigh.value;
        this.apply();
      });
      this.form.addEventListener('reset', () => {
        requestAnimationFrame(() => {
          this.pLow.value = 0; this.pHigh.value = this.priceMax;
          this.apply();
        });
      });
      this.querySelector('[data-sort]').addEventListener('change', () => this.apply());
      const query = new URLSearchParams(location.search);
      ['metal', 'feature', 'shape', 'carat'].forEach(group => {
        query.getAll('ring_' + group).forEach(value => {
          this.form.querySelectorAll('input[name="' + group + '"]').forEach(el => { if (el.value === value) el.checked = true; });
        });
      });
      [['price_min', this.pLow], ['price_max', this.pHigh]].forEach(([key, el]) => {
        const v = query.get('ring_' + key);
        if (v !== null && Number.isFinite(Number(v))) el.value = v;
      });
      const sort = query.get('ring_sort');
      if (sort && [...this.querySelector('[data-sort]').options].some(o => o.value === sort)) this.querySelector('[data-sort]').value = sort;
      this.apply();
    }
    apply() {
      const data = new FormData(this.form);
      const metals = data.getAll('metal'), features = data.getAll('feature'), shapes = data.getAll('shape'), carats = data.getAll('carat').map(Number);
      this.form.querySelectorAll('input[type="checkbox"]').forEach(input => {
        const possible = this.items.some(item =>
          (input.name === 'metal' ? item.metal === input.value : !metals.length || metals.includes(item.metal)) &&
          (input.name === 'shape' ? item.shape === input.value : !shapes.length || shapes.includes(item.shape)) &&
          (input.name === 'feature' ? item[input.value] : !features.length || features.some(f => item[f])) &&
          (input.name === 'carat' ? item.carat === Number(input.value) : !carats.length || carats.includes(item.carat)) &&
          item.priceMax >= +this.pLow.value && item.price <= +this.pHigh.value);
        input.disabled = !input.checked && !possible;
      });
      let count = 0;
      for (const item of this.items) {
        const visible = (!metals.length || metals.includes(item.metal)) && (!features.length || features.some(f => item[f])) && (!shapes.length || shapes.includes(item.shape)) && item.priceMax >= +this.pLow.value && item.price <= +this.pHigh.value && (!carats.length || carats.includes(item.carat));
        item.el.hidden = !visible;
        if (visible) count++;
      }
      const money = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP', maximumFractionDigits: 0 });
      this.querySelector('[data-price-min]').textContent = money.format(+this.pLow.value);
      this.querySelector('[data-price-max]').textContent = money.format(+this.pHigh.value);
      this.querySelector('.dr-count').textContent = this.dataset.countTemplate.replace('__COUNT__', count);
      this.querySelector('.dr-empty').hidden = count !== 0;
      const sort = this.querySelector('[data-sort]').value;
      const ordered = [...this.items].sort((a, b) => sort === 'price-ascending' ? a.price - b.price : sort === 'price-descending' ? b.price - a.price : sort === 'carat-ascending' ? a.carat - b.carat : sort === 'carat-descending' ? b.carat - a.carat : (['round','oval','pear','emerald_cut','cushion','radiant','marquise'].indexOf(a.shape) - ['round','oval','pear','emerald_cut','cushion','radiant','marquise'].indexOf(b.shape)) || a.carat - b.carat || a.title.localeCompare(b.title));
      ordered.forEach(i => this.grid.append(i.el));
      const url = new URL(location.href);
      url.searchParams.delete('sort_by');
      url.searchParams.delete('page');
      [...url.searchParams.keys()].filter(k => k.startsWith('ring_')).forEach(k => url.searchParams.delete(k));
      ['metal', 'feature', 'shape', 'carat'].forEach(group => data.getAll(group).forEach(v => url.searchParams.append('ring_' + group, v)));
      if (+this.pLow.value > 0) url.searchParams.set('ring_price_min', this.pLow.value);
      if (+this.pHigh.value < this.priceMax) url.searchParams.set('ring_price_max', this.pHigh.value);
      if (sort !== 'manual') url.searchParams.set('ring_sort', sort);
      history.replaceState({}, '', url);
    }
  });
}
